// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__AdvancedSearch_General .Polaris-Layout {
  text-align: center;
}

.BC-Page__AdvancedSearch_General .heading {
  margin: 8px auto;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
}

.BC-Page__AdvancedSearch_General .text-color {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__AdvancedSearch_General .search-block {
  width: 420px;
  margin: auto;
  border: 0.7px solid #008060;
  border-radius: 8px;
}

.BC-Page__AdvancedSearch_General .search-block-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.BC-Page__AdvancedSearch_General .search-block img {
  width: 24px;
}

.BC-Page__AdvancedSearch_General .content-features {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 20px;
}

.BC-Page__AdvancedSearch_General .content-features .feature {
  flex-basis: 50%;
  max-width: 320px;
  position: relative;
}

.BC-Page__AdvancedSearch_General .Polaris-Card {
  margin: 0;
  background: #fafbfb;
  box-shadow: none;
  outline: none;
}

.BC-Page__AdvancedSearch_General .content-features .Polaris-Card {
  text-align: left;
}

.BC-Page__AdvancedSearch_General .content-features .card-content {
  padding: 12px 16px;
}

.BC-Page__AdvancedSearch_General .content-features .card-content .title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__AdvancedSearch_General .content-features .card-content .content {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 2px 10px;
}

.BC-Page__AdvancedSearch_General .content-result .Polaris-Card {
  width: 100%;
  max-width: 258px;
  margin: auto;
}

.BC-Page__AdvancedSearch_General .content-result .Polaris-Card__Header .Polaris-Heading,
.BC-Page__AdvancedSearch_General .content-final-result .Polaris-Card__Header .Polaris-Heading {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__AdvancedSearch_General .content-final-result .Polaris-Card {
  background: var(--p-surface-primary-selected);
  width: 100%;
  max-width: 740px;
  margin: auto;
}

.BC-Page__AdvancedSearch_General .arrow-direction {
  width: 50%;
  margin: 0 auto;
}

.BC-Page__AdvancedSearch_General .arrow-direction img {
  width: 100%;
  vertical-align: middle;
}

/* custom banner */
.aiSearchPromoteBanner {
  margin-top: 4rem !important;
  padding: 16px;
  gap: 10px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(163.96deg, #fff2f9 10.15%, #e8f7ff 105.86%);
  text-align: left;
}

.aiSearchPromoteBanner .title {
  position: relative;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.aiSearchPromoteBanner .title img {
  margin-right: 2px;
}

.aiSearchPromoteBanner .pfs-banner-detail {
  margin-top: 5px;
}

.aiSearchPromoteBanner .pfs-banner-content {
  display: flex;
  padding: 0;
  padding-left: 20px;
}

.aiSearchPromoteBanner .action {
  position: absolute;
  top: 0;
  right: 0;
}

.aiSearchPromoteBanner .sub-content {
  width: 33%;
  padding: 8px;
}

.aiSearchPromoteBanner .sub-content .sub-content-title {
  color: #202223;
  border-bottom: 3px dotted #dfe3e8;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.aiSearchPromoteBanner .sub-content .sub-content-value {
  margin: 2px 0 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.aiSearchPromoteBanner .backgroundImage img {
  max-width: 73px;
}
/* end banner */
`, "",{"version":3,"sources":["webpack://./src/styles/advanced-search-general.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;AACA,eAAe","sourcesContent":[".BC-Page__AdvancedSearch_General .Polaris-Layout {\n  text-align: center;\n}\n\n.BC-Page__AdvancedSearch_General .heading {\n  margin: 8px auto;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.BC-Page__AdvancedSearch_General .text-color {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__AdvancedSearch_General .search-block {\n  width: 420px;\n  margin: auto;\n  border: 0.7px solid #008060;\n  border-radius: 8px;\n}\n\n.BC-Page__AdvancedSearch_General .search-block-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.BC-Page__AdvancedSearch_General .search-block img {\n  width: 24px;\n}\n\n.BC-Page__AdvancedSearch_General .content-features {\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.BC-Page__AdvancedSearch_General .content-features .feature {\n  flex-basis: 50%;\n  max-width: 320px;\n  position: relative;\n}\n\n.BC-Page__AdvancedSearch_General .Polaris-Card {\n  margin: 0;\n  background: #fafbfb;\n  box-shadow: none;\n  outline: none;\n}\n\n.BC-Page__AdvancedSearch_General .content-features .Polaris-Card {\n  text-align: left;\n}\n\n.BC-Page__AdvancedSearch_General .content-features .card-content {\n  padding: 12px 16px;\n}\n\n.BC-Page__AdvancedSearch_General .content-features .card-content .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__AdvancedSearch_General .content-features .card-content .content {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin: 0 2px 10px;\n}\n\n.BC-Page__AdvancedSearch_General .content-result .Polaris-Card {\n  width: 100%;\n  max-width: 258px;\n  margin: auto;\n}\n\n.BC-Page__AdvancedSearch_General .content-result .Polaris-Card__Header .Polaris-Heading,\n.BC-Page__AdvancedSearch_General .content-final-result .Polaris-Card__Header .Polaris-Heading {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__AdvancedSearch_General .content-final-result .Polaris-Card {\n  background: var(--p-surface-primary-selected);\n  width: 100%;\n  max-width: 740px;\n  margin: auto;\n}\n\n.BC-Page__AdvancedSearch_General .arrow-direction {\n  width: 50%;\n  margin: 0 auto;\n}\n\n.BC-Page__AdvancedSearch_General .arrow-direction img {\n  width: 100%;\n  vertical-align: middle;\n}\n\n/* custom banner */\n.aiSearchPromoteBanner {\n  margin-top: 4rem !important;\n  padding: 16px;\n  gap: 10px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(163.96deg, #fff2f9 10.15%, #e8f7ff 105.86%);\n  text-align: left;\n}\n\n.aiSearchPromoteBanner .title {\n  position: relative;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.aiSearchPromoteBanner .title img {\n  margin-right: 2px;\n}\n\n.aiSearchPromoteBanner .pfs-banner-detail {\n  margin-top: 5px;\n}\n\n.aiSearchPromoteBanner .pfs-banner-content {\n  display: flex;\n  padding: 0;\n  padding-left: 20px;\n}\n\n.aiSearchPromoteBanner .action {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.aiSearchPromoteBanner .sub-content {\n  width: 33%;\n  padding: 8px;\n}\n\n.aiSearchPromoteBanner .sub-content .sub-content-title {\n  color: #202223;\n  border-bottom: 3px dotted #dfe3e8;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.aiSearchPromoteBanner .sub-content .sub-content-value {\n  margin: 2px 0 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.aiSearchPromoteBanner .backgroundImage img {\n  max-width: 73px;\n}\n/* end banner */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
